import { createContext } from "react";

export const BoardContext = createContext(null);
export const GameContext = createContext(null);